<template>
  <div>
    <!-- 顶部导航 -->
    <HeaderTemplate></HeaderTemplate>

    <!-- 路由组件展示区：根据 URL 变化，这里的内容会动态替换 -->
    <main>
      <router-view></router-view>
    </main>
    <FooterTemplate></FooterTemplate>
  </div>
</template>

<script>
import HeaderTemplate from './components/template/HeaderTemplate.vue'
import FooterTemplate from './components/template/FooterTemplate.vue'
export default {
  name: 'App',
  components: {
    HeaderTemplate,
    FooterTemplate
  }
}

</script>

<style>
body {
  margin: 0 auto;
}

#app {
  font-family: "MiSans", "PingFang SC", "Noto", "roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
